export enum NutritionDayStatus {
  NO_MEAL = 'NO_MEAL',
  NO_GOAL = 'NO_GOAL',
  PARTIAL_GOAL = 'PARTIAL_GOAL',
  ALL_GOALS = 'ALL_GOALS',
  EXCEEDED_ALL_GOALS = 'EXCEEDED_ALL_GOALS'
}

export interface NutritionMealItem {
  _id: number
  meal_record_id: number
  food_external_id: string
  name: string
  icon_id: string
  serving_quantity: number
  serving_unit: string
  weight_grams: number
  calories: number
  protein: number
  carbs: number
  fat: number
  _created: string
  _updated: string | null
}

export interface NutritionMeal {
  _id: number
  user_id: number
  meal_type: string
  timestamp: string
  day: string
  notes: string
  items: NutritionMealItem[]
  nutrition: {
    calories: number
    protein: number
    carbs: number
    fat: number
  }
  _created: string
  _updated: string | null
}

export interface NutritionDailySummary {
  day: string
  status: NutritionDayStatus
  meals: NutritionMeal[]
  goal: {
    _id: number
    user_id: number
    daily_calories: number
    daily_protein: number
    daily_carbs: number
    daily_fat: number
    start_date: number
    _created: string
    _updated: string | null
  } | null
  nutrition: {
    calories: number
    protein: number
    carbs: number
    fat: number
  }
}

export interface NutritionMonthlySummaryItem {
  day: string
  meals: NutritionMeal[]
  status: NutritionDayStatus
  goal: {
    _id: number
    user_id: number
    daily_calories: number
    daily_protein: number
    daily_carbs: number
    daily_fat: number
    start_date: number
    _created: string
    _updated: string | null
  } | null
  nutrition: {
    calories: number
    protein: number
    carbs: number
    fat: number
  }
}

export type NutritionMonthlySummary = NutritionMonthlySummaryItem[]

export interface NutritionStore {
  getNutritionMonthlySummary: (
    userId: number,
    month: string,
    year: number
  ) => Promise<NutritionMonthlySummary | null>
  getNutritionDailySummary: (
    userId: number,
    date: string
  ) => Promise<NutritionDailySummary | null>
  getIconUrl: (iconId: string, size: number) => string
}
